<template>
    <div>
    


        <div class="text-body-1 pb-3">Введите код с изображения</div>
        <img :src="captchaImage" />

        <sg-text-field ref="answer" label="Проверочный код" v-model="answer" :rules="answerRules"
            @keyup.enter.stop.prevent="onSolve" @keydown.tab.stop.prevent="onSolve" autofocus autocomplete="off" />

        <v-btn :disabled="!solved" class="mt-3" color="primary" depressed @click.stop="onSolve">Далее</v-btn>

    </div>
</template>

<script>
    export default {
        props: {
            captchaImage: {
                type: String,
                required: true
            }
        },
        computed: {
            solved() {
                return !!this.answer
            }
        },
        data() {
            return {
                answer: '',
                answerRules: [
                    v => !!v || 'Введите текст с изображения'
                ],
            }
        },
        methods: {
            onSolve() {
                if (this.solved) {
                    let answer = this.answer
                    this.answer = ''
                    this.$emit('solve', answer)
                }
            }
        }
    }
</script>

<style>

</style>